import React from "react";
import { Box } from "@mui/material";
import { WarningTelemetry } from "./WarningTelemetry";

type Props = {
  altitude?: null | number;
  battery?: null | number;
  heading?: null | number;
  speed?: null | number;
  location?: null | [number, number];
};

export const Telemetry = ({
  altitude,
  battery,
  heading,
  speed,
  location,
}: Props) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <WarningTelemetry
        name="Altitude"
        value={`${altitude}m`}
        warning={{ message: "", type: "info" }}
      />
      <WarningTelemetry
        name="Battery"
        value={`${battery}v`}
        warning={{ message: "", type: "info" }}
      />
      <WarningTelemetry
        name="Heading"
        value={`${heading}`}
        warning={{ message: "", type: "info" }}
      />
      {speed ? (
        <WarningTelemetry
          name="Speed"
          value={`${speed}mph`}
          warning={{ message: "", type: "info" }}
        />
      ) : null}
      <WarningTelemetry
        name="Location"
        value={`${location?.[0].toFixed(5)}, ${location?.[1].toFixed(5)}`}
        warning={{ message: "", type: "info" }}
      />
    </Box>
  );
};
